<template>
  <dynamic-input
    v-model="value"
    :options="filter"
    :no-label="noLabel"
    :class="version === 1 ? 'mr-4' : ''"
    :min-width="version === 1"
    :body-render="bodyRender"
    :datatable-id="datatableId"
  ></dynamic-input>
</template>

<script>
// Docs: app/javascript/components/DatatableFilter.md
import { isFalsy } from "@/lib/helpers.js";
import { getQueryVariables, updateQueryParam } from "@/lib/url.js";

import DynamicInput from "@/components/DynamicInput.vue";

export default {
  components: {
    DynamicInput
  },
  props: {
    filter: {
      type: Object,
      default: () => ({})
    },
    noLabel: {
      // passed through
      type: Boolean,
      default: false
    },
    version: {
      type: Number,
      default: 1
    },
    bodyRender: {
      type: Boolean,
      default: true
    },
    datatableId: {
      type: String,
      default: ""
    }
  },
  emits: ["refresh-table"],
  data() {
    return {
      value: this.filter.default_value
    };
  },
  computed: {
    paramName() {
      return this.datatableId
        ? `${this.datatableId}_${this.filter.name}`
        : this.filter.name;
    }
  },
  watch: {
    value(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.handleFilterChange(newValue);
      }
    }
  },
  created() {
    this.setInitialFilters();
  },
  methods: {
    clearValue() {
      this.value = "";
    },
    async handleFilterChange(value) {
      // Handle query param parsing on page to prevent duplicate requests
      // should only refresh table if the filter is removed or has changed values
      if (isFalsy(value) || !this.isFilterApplied(value)) {
        await updateQueryParam(this.paramName, value, true);
        this.$emit("refresh-table");
      }
    },
    isFilterApplied(value) {
      // Check if filter is already applied
      const params = getQueryVariables();
      return params[this.paramName] == value;
    },
    async setInitialFilters() {
      const params = getQueryVariables();
      const paramValue = params[this.paramName];
      const hasParam = !isFalsy(paramValue);
      const hasDefault = !isFalsy(this.filter.default_value);
      const isV1 = this.version === 1;

      if (hasParam) {
        this.value = paramValue;
        return;
      }

      if (hasDefault) {
        if (isV1) {
          await this.handleFilterChange(this.filter.default_value);
          const updated = getQueryVariables()[this.paramName];
          this.value = !isFalsy(updated) ? updated : this.filter.default_value;
          return;
        } else {
          this.value = this.filter.default_value;
          return;
        }
      }

      this.value = undefined;
    }
  }
};
</script>

<style lang="scss" scoped></style>
